<!DOCTYPE html>
<template>
	<main id="main-content" class="container py-4">
		<b-overlay :show="compiling" rounded="sm">
			<!-- FS Set header card -->
			<b-card class="mb-4" no-body>
				<b-card-header>
					<h2 class="secudoc-card-heading">{{ financialStatementSet.documentName }}</h2>
				</b-card-header>
				<b-list-group flush>
					<b-list-group-item><strong>Organization:</strong> {{ financialStatementSet.organizationName }}</b-list-group-item>
					<b-list-group-item><strong>Created:</strong> {{ createdDateFormatted }}</b-list-group-item>
				</b-list-group>
			</b-card>

			<!-- Pages table -->
			<b-table
				id="pages_table"
				striped hover responsive
				:items="fsSetPages"
				:fields="pageFields"
				show-empty
				empty-text="No pages found for this statement set."
			>
				<template #cell(actions)="data">
					<b-button size="sm" variant="outline-primary" @click="viewPage(data.item)">
						View Page
					</b-button>
				</template>
			</b-table>

			<!-- Compile form -->
			<div class="mt-3">
				<b-form @submit.prevent="compileImages">
					<b-button type="submit" variant="primary" :disabled="compiling">
						{{ compiling ? 'Compiling…' : 'Compile Pages to PDF' }}
					</b-button>
				</b-form>
				<div role="status" aria-live="polite" class="mt-2">
					<b-button
						v-if="isCompilingComplete"
						:href="downloadUrl"
						variant="success"
						target="_blank"
						rel="noopener"
					>Download Compiled PDF</b-button>
				</div>
			</div>
		</b-overlay>

		<b-modal ref="page-viewer" :title="'Page ' + pageViewNum" ok-only size="xl" body-class="p-0">
			<div v-if="pageViewLoading" class="d-flex justify-content-center align-items-center py-5">
				<b-spinner label="Loading page image..."/>
			</div>
			<b-img
				v-else-if="pageViewUrl"
				:src="pageViewUrl"
				fluid
				:alt="'Page ' + pageViewNum"
				class="w-100 d-block"
			/>
			<div v-else class="text-center py-4 text-muted">Could not load page image.</div>
		</b-modal>
	</main>
</template>
<script>
	import firebase from "firebase/compat/app";
	import "firebase/compat/auth";
	import "firebase/compat/firestore";
	import "firebase/compat/storage";
	import axios from "axios";
	const config = require("../firebaseconfig.js");
	import { logEvent } from '@/firebaseAnalytics';

	class FinancialStatementSet {
		constructor() {
		
		}
	}
	var financialStatementSetConverter = {
		toFirestore: function(financialStatementSet) {
			return {
				createdDate: financialStatementSet.createdDate,
				documentName: financialStatementSet.documentName,
				organizationName: financialStatementSet.organizationName,
				referenceDocumentUri: financialStatementSet.referenceDocumentUri,
				uploadedBy: financialStatementSet.uploadedBy,
			}
		},
		fromFirestore: function(snapshot, options) {
			const data = snapshot.data(options);
			var financialStatementSet = new FinancialStatementSet();
				financialStatementSet.createdDate = data.createdDate;
				financialStatementSet.documentName = data.documentName;
				financialStatementSet.organizationName = data.organizationName;
				financialStatementSet.referenceDocumentUri = data.referenceDocumentUri;
				financialStatementSet.uploadedBy = data.uploadedBy;
			return financialStatementSet;
		}
	}
	export default {
		mounted() {
			this.getFinancialStatementSets(this.$route.params.id);
		},
		methods: {
			getFinancialStatementSets: async function(fsSetId) {
				firebase.firestore().collection("FinancialStatementSet")
					.doc(fsSetId).withConverter(financialStatementSetConverter)
					.get().then(fsSetSnapshot => {
						var fsSet = fsSetSnapshot.data();
						this.financialStatementSet = fsSet;

						if (fsSet.createdDate && typeof fsSet.createdDate.toDate === 'function') {
							this.createdDateFormatted = fsSet.createdDate.toDate().toLocaleDateString('en-US');
						} else {
							this.createdDateFormatted = fsSet.createdDate || '—';
						}

						return fsSetSnapshot.ref.collection("Page")
							.orderBy("storageRef", "asc").get();
					}).then(pagesSnapshot => {
						this.fsSetPages = [];
						let pageNum = 1;
						pagesSnapshot.forEach((pageSnapshot) => {
							var verifiedUrl = pageSnapshot.data().storageRef;
							var preVerifiedUrl = verifiedUrl.replace("verified", "pre-verification");
							var fsSetPage = {
								pageNum: pageNum++,
								id: pageSnapshot.id,
								preVerifiedUrl: preVerifiedUrl,
								verifiedUrl: verifiedUrl,
							}
							this.fsSetPages.push(fsSetPage);
						});
					});
			},
			viewPage(page) {
				logEvent('fs_set_page_viewed', { page_num: page.pageNum });
				this.pageViewLoading = true;
				this.pageViewNum = page.pageNum;
				this.pageViewUrl = '';
				this.$refs['page-viewer'].show();
				firebase.storage().ref(page.verifiedUrl).getDownloadURL()
					.then(url => {
						this.pageViewUrl = url;
						this.pageViewLoading = false;
					})
					.catch(() => {
						// Fall back to pre-verified (Cloud Function may not have processed yet)
						firebase.storage().ref(page.preVerifiedUrl).getDownloadURL()
							.then(url => {
								this.pageViewUrl = url;
								this.pageViewLoading = false;
							})
							.catch(err => {
								this.pageViewLoading = false;
								this.$bvToast.toast('Could not load page image.', {
									title: 'Error', variant: 'danger', solid: true
								});
							});
					});
			},
			compileImages() {
				this.compiling = true;
				var req = {
					financialStatementSetId: this.$route.params.id,
				};
				axios.post(config.functionBaseUrl + "/compileVerifiedFsSet", req)
					.then(response => {
						this.compiling = false;
						logEvent('fs_set_compiled', { fs_set_id: this.$route.params.id });
						this.downloadUrl = response.data;
						this.isCompilingComplete = true;
					}).catch(error => {
						this.compiling = false;
						console.error("error  " + error);
						this.$bvToast.toast('Failed to compile FS Set: ' + error, {
							title: 'Error', variant: 'danger', solid: true, noAutoHide: true
						});
					}
				);
			}
		},
		data() {
			return {
				financialStatementSet: {},
				fsSetPages: [],
				pageFields: [
					{ key: 'pageNum', label: 'Page' },
					{ key: 'actions', label: '' }
				],
				createdDateFormatted: '—',
				isCompilingComplete: false,
				downloadUrl: "",

				compiling: false,

				pageViewUrl: '',
				pageViewNum: null,
				pageViewLoading: false
			}
		}
	}
</script>

<style lang="scss" scoped>

</style>
